import React from "react";
// react components for routing our app without refresh
import { Link, NavLink } from "react-router-dom";
// redux
import { useSelector, useDispatch } from "react-redux";
import { toggleLost, toggleFound } from "../../redux/actions/FlashActions.js";
import { logoutUser } from "../../redux/actions/AuthActions.js";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Slide from "@material-ui/core/Slide";
// @material-ui/icons
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import GroupIcon from "@material-ui/icons/Group";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ReportIcon from "@material-ui/icons/Report";
import ViewListIcon from "@material-ui/icons/ViewList";
// core components
import Button from "components/CustomButtons/Button.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import LostModal from "components/Modal/LostModal.js";
import FoundModal from "components/Modal/FoundModal.js";
// other
import { toast, Zoom } from "react-toastify";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const useStyles = makeStyles(styles);

const toastOptions = {
  transition: Zoom,
  position: "bottom-right",
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
};

export default function HeaderRightLinks() {
  const classes = useStyles();
  const profileImgClasses = classNames(classes.img, classes.imgCard);

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const handleLogout = () => {
    if (!auth.isAuthenticated) {
      toast.error("You are not logged in!", toastOptions);
      return;
    }
    logoutUser(dispatch);
  };

  var personalMenu;
  var adminMenu = <></>;
  if (auth.isAuthenticated) {
    if (auth.user.isAdmin) {
      adminMenu = (
        <>
          <ListItem className={classes.listItem}>
            <NavLink to="/claimrequests" className={classes.navLink}>
              <ViewListIcon className={classes.icons} /> Manage Requests
            </NavLink>
          </ListItem>
          <ListItem className={classes.listItem}>
            <NavLink to="/users" className={classes.navLink}>
              <GroupIcon className={classes.icons} /> Users
            </NavLink>
          </ListItem>
        </>
      );
    }
    personalMenu = (
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          left
          caret={false}
          dropdownHeader="Personal Menu"
          buttonText={
            <>
              <img
                src={auth.user.imageId}
                className={profileImgClasses}
                alt="profile"
              />
              <div className="ml-2">{auth.user.username}</div>
            </>
          }
          buttonProps={{
            className: classes.navLink + " " + classes.imageDropdownButton,
            color: "transparent",
          }}
          dropdownList={[
            // <Link to="/lostitems/my" className={classes.dropdownLink}>
            //   My Lost Items
            // </Link>,
            // <Link to="/founditems/my" className={classes.dropdownLink}>
            //   My Found Items
            // </Link>,
            // <Link to="/itemshistory/my" className={classes.dropdownLink}>
            //   My History
            // </Link>,
            <Link
              key="MyProfile"
              to={"/users/" + auth.user.username}
              className={classes.dropdownLink}
            >
              My Profile
            </Link>,
            <Link
              key="EditProfile"
              to="/users/editprofile"
              className={classes.dropdownLink}
            >
              Edit Profile
            </Link>,
            <Button
              key="Logout"
              simple
              onClick={handleLogout}
              className={classes.dropdownLink}
            >
              Logout
            </Button>,
          ]}
        />
      </ListItem>
    );
  } else {
    personalMenu = (
      <>
        <ListItem className={classes.listItem}>
          <NavLink to="/users/login" className={classes.navLink}>
            <AccountCircleIcon className={classes.icons} /> Login
          </NavLink>
        </ListItem>

        <ListItem className={classes.listItem}>
          <NavLink to="/users/signup" className={classes.navLink}>
            <PersonAddIcon className={classes.icons} /> Signup
          </NavLink>
        </ListItem>
      </>
    );
  }

  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          left
          buttonText="Report"
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
          }}
          buttonIcon={ReportIcon}
          dropdownList={[
            <Button
              key="LostItem"
              simple
              onClick={() => toggleLost(dispatch)}
              className={classes.dropdownLink}
            >
              Lost Item
            </Button>,
            <Button
              key="FoundItem"
              simple
              onClick={() => toggleFound(dispatch)}
              className={classes.dropdownLink}
            >
              Found Item
            </Button>,
          ]}
        />
        <LostModal />
        <FoundModal />
      </ListItem>

      {adminMenu}
      {personalMenu}
    </List>
  );
}
